import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';


const basename = process.env.PUBLIC_URL;
i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  //.use(LanguageDetector)
  .init({
    fallbackLng: 'fi',
    whitelist: ['fi'],
    backend: {
      loadPath: basename + '/locales/{{lng}}/{{ns}}.json',
    },
    ns: ['common', 'login', 'dashboard', 'voucherManagement', 'userManagement', 'reports', 'header'],
    interpolation: {
      escapeValue: false, // react already safes from xss
      format: function (value, format, lng) {
        if (format === 'lowercase') return value.toLowerCase();
        return value;
      }
    },
    /*detection: {
      checkWhitelist: true,
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },*/
  });

export default i18n;
